import { render, staticRenderFns } from "./CourseSkeleton.vue?vue&type=template&id=d3c0695c&scoped=true&"
import script from "./CourseSkeleton.vue?vue&type=script&lang=js&"
export * from "./CourseSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CourseSkeleton.vue?vue&type=style&index=0&id=d3c0695c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c0695c",
  null
  
)

export default component.exports